export default __webpack_public_path__ + "static/media/t3.87a0b3da.png";